import { render, staticRenderFns } from "./RentedProducts.vue?vue&type=template&id=120fd7be&scoped=true"
import script from "./RentedProducts.vue?vue&type=script&lang=js"
export * from "./RentedProducts.vue?vue&type=script&lang=js"
import style0 from "./RentedProducts.vue?vue&type=style&index=0&id=120fd7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120fd7be",
  null
  
)

export default component.exports